import React, { ReactElement, useState } from 'react'

import ClickAwayListener from '@mui/material/ClickAwayListener'
import Tooltip from '@mui/material/Tooltip'

interface TooltipProps {
  title: string
  children: ReactElement
  placement?:
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | undefined
}

export const TooltipComponent = ({ title, children, placement = 'top' }: TooltipProps) => {
  const [open, setOpen] = useState(false)

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        onClick={() => setOpen(true)}
        PopperProps={{
          disablePortal: true,
        }}
        placement={placement}
        onClose={() => setOpen(false)}
        open={open}
        disableTouchListener
        title={title}
      >
        {children}
      </Tooltip>
    </ClickAwayListener>
  )
}
